<script lang="ts">
  import { uniqueId } from "../functions";

  let _target: HTMLElement;
  let labelledBy: HTMLElement;
  let describedBy: HTMLElement;

  export const label = (n: HTMLElement) => {
    n.setAttribute("id", uniqueId("ln-title"));
    labelledBy = n;
    updateTarget();
  };

  export const description = (n: HTMLElement) => {
    n.setAttribute("id", uniqueId("ln-description"));
    describedBy = n;
    updateTarget();
  };

  const updateTarget = () => {
    if (!_target) return;
    _target.setAttribute("aria-labelledby", labelledBy?.id);
    _target.setAttribute("aria-describedby", describedBy?.id);
  };

  const target = (n: HTMLElement) => {
    _target = n;
    updateTarget();
  };
</script>

<slot aria={{ target, label, description }} />
